/*
 * Copyright © 2017-2021 Skale Education Inc. - All Rights Reserved
 */

import React from "react";
import { View, TouchableOpacity, StyleSheet } from "react-native";
import Icon from "react-icons-kit";
import { x as cross } from "react-icons-kit/feather/x";

import { FadeInOutView, Text } from "UpduoLibrary";
import {
  upduoPrimaryBlack,
  upduoPrimaryBlue,
  upduoMediumGray,
} from "config/UpduoColors";

const styles = StyleSheet.create({
  cellStyle: {
    color: upduoPrimaryBlack,
  },
  center: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  horizontalLine: {
    height: 0,
    width: "100%",
    borderWidth: 1,
    borderStyle: "solid",
    borderColor: upduoPrimaryBlue,
  },
  formulaRow: { flexDirection: "row", alignItems: "stretch", marginTop: 8 },
  formulaSymbol: { marginHorizontal: 12, fontSize: 18 },
});

export default function OnTrackInfoPopup({
  isVisible,
  onClose,
}: {
  isVisible: boolean;
  onClose: () => void;
}) {
  if (!isVisible) {
    return null;
  }

  return (
    <FadeInOutView
      style={{
        position: "absolute",
        width: 375,
        marginLeft: -187, // half of width
        marginTop: 8,
        backgroundColor: "white",
        shadowColor: "rgba(0, 0, 0, 0.25)",
        shadowRadius: 6,
        borderRadius: 8,
        padding: 12,
        flexDirection: "column",
        alignItems: "stretch",
      }}
    >
      <View
        style={{
          flexDirection: "row",
          justifyContent: "space-between",
          alignItems: "flex-start",
        }}
      >
        <Text
          style={{
            fontSize: 16,
            color: upduoPrimaryBlack,
          }}
        >
          {"Formula Calculation"}
        </Text>
        <TouchableOpacity
          style={{
            marginLeft: 8,
          }}
          onPress={onClose}
        >
          <Icon
            size={14}
            icon={cross}
            style={{
              color: upduoMediumGray,
            }}
          />
        </TouchableOpacity>
      </View>
      <View style={styles.formulaRow}>
        <Text style={styles.center}>{"Total Quota"}</Text>
        <Text style={[styles.center, styles.formulaSymbol]} isHeading={true}>
          {"="}
        </Text>
        <Text style={styles.center}>{"Individual Quota"}</Text>
        <Text style={[styles.center, styles.formulaSymbol]} isHeading={true}>
          {"x"}
        </Text>
        <Text style={styles.center}>{"# of Users"}</Text>
      </View>
      <View style={styles.formulaRow}>
        <Text style={styles.center}>{"Quota Progress"}</Text>
        <Text style={[styles.center, styles.formulaSymbol]} isHeading={true}>
          {"="}
        </Text>
        <View style={[styles.center, { flexDirection: "column" }]}>
          <Text style={styles.center}>{"# of sessions done"}</Text>
          <View style={styles.horizontalLine} />
          <Text style={styles.center}>{"Total Quota"}</Text>
        </View>
      </View>
      <View style={styles.formulaRow}>
        <Text style={styles.center}>{"On Track"}</Text>
        <Text style={[styles.center, styles.formulaSymbol]} isHeading={true}>
          {"="}
        </Text>
        <View style={[styles.center, { flexDirection: "column" }]}>
          <Text style={styles.center}>{"Total"}</Text>
          <Text style={styles.center}>{"Quota"}</Text>
        </View>
        <Text style={[styles.center, styles.formulaSymbol]} isHeading={true}>
          {"x"}
        </Text>
        <View style={[styles.center, { flexDirection: "column" }]}>
          <Text style={styles.center}>{"day of the month"}</Text>
          <View style={styles.horizontalLine} />
          <Text style={styles.center}>{"days in the month"}</Text>
        </View>
      </View>
    </FadeInOutView>
  );
}
